<template>
  <section class="webinar-hero">
    <v-container style="position: relative" v-if="!isSmallDevice">
      <hero-shape :is-open="isOpen" hero-md-width="100%" hero-lg-width="65%" hero-xl-width="60%">
        <div class="webinar-hero__wrapper">
          <rwl-heading h="3" class="rwl-heading" v-html="$t('webinars.hero_title')"></rwl-heading>
          <div class="webinar-hero__content">
            <rwl-heading h="5" v-html="$t('webinars.hero_subtitle')"></rwl-heading>
            <p v-html="$t('webinars.hero_description')" class="webinar-hero__description"></p>
          </div>
          <div class="webinar-hero__buttons">
            <hero-button-leaflet tag="a" target="_blank"
                                 :href="`${PUBLIC_PATH}downloads/${$t('webinars.hero_download_filename')}`"
            >
              {{$t('webinars.hero_leaflet_button')}}
            </hero-button-leaflet>
          </div>
        </div>
      </hero-shape>
      <hero-full-content :is-open="isOpen">
        <slot name="fullContent"></slot>
      </hero-full-content>
    </v-container>

    <v-container v-if="isSmallDevice">
      <div class="webinar-hero__wrapper">

        <rwl-heading h="3" class="rwl-heading" v-html="$t('webinars.hero_title')"></rwl-heading>
        <rwl-heading h="5" class="rwl-heading" v-html="$t('webinars.hero_subtitle')"></rwl-heading>

        <div class="webinar-hero__content">
          <p class="webinar-hero__description" v-html="$t('webinars.hero_description')"></p>
        </div>

        <div class="webinar-hero__buttons">
          <slot name="buttons"></slot>
        </div>

      </div>
    </v-container>
  </section>
</template>

<script>
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library";
  import { VContainer } from './ui/index';
  import { HeroShape, HeroFullContent } from "./hero";
  import HeroButtonLeaflet from "./hero/HeroButtonLeaflet";

  const smallDeviceCheck = (mq, vm) => vm.isSmallDevice = mq.matches

  export default {
    name: "WebinarHero",
    components: { HeroShape, VContainer, RwlHeading, HeroFullContent,
      HeroButtonLeaflet },
    data() {
      return {
        isOpen: false,
        isSmallDevice: false,
        PUBLIC_PATH: process.env.VUE_APP_ASSETS_PATH,
      }
    },
    created() {
      const mql = window.matchMedia('(max-width: 767.98px)');
      let self = this;

      mql.addListener((mq) => smallDeviceCheck(mq, this))
      smallDeviceCheck(mql, this)
    },
    methods: {
      readmeClicked() {
        this.$emit('readMore');
        this.isOpen = !this.isOpen
      }
    },
    computed: {
      fullContentStyleMobile() {

        return {
          "max-height": this.isOpen ? "1000px" : "0px",
          "height": "auto",
          "overflow": "hidden"
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../variables";

  .webinar-hero {
    position: relative;
    color: $color-rwl-white-100;
    font-size: $font-size-rwl-body;
    background-color: $color-rwl-blue-100;
  }

  .v-container {
    position: relative;
    height: 100%;
  }

  .rwl-heading {
    color: $color-rwl-white-100;

    &.h3 {
      padding: 0 $spacing-5;
    }

    &.h5 {
      padding: 0 $spacing-5;
    }
  }

  .webinar-hero__wrapper {
    padding-top: $spacing-8;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .webinar-hero__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    font-size: $font-size-rwl-headline-6;
    line-height: $line-height-rwl-headline-6;
    font-weight: $font-weight-light;
    padding: 0 $spacing-5;
  }

  .webinar-hero__description-button {
    margin-top: auto;
  }

  .webinar-hero__buttons {
    margin-top: $spacing-3;
    display: flex;
    align-items: center;
    padding: $spacing-6 $spacing-5 $spacing-6;

  }

  .webinar-hero__full-content--mobile {
    transition: max-height 400ms;
  }

  @media (min-width: $breakpoint-md-min) {
    .webinar-hero__wrapper {
      padding-top: $spacing-5;
    }

    .webinar-hero {
      height: 560px;
      background: url('#{$assetsPath}images/hero_background_2.jpg');
      background-size: cover;
      position: relative;
      color: $color-rwl-white-100;
      overflow: hidden;
    }
  }
</style>
